var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pickup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pickup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0.141587409,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "group-17",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.04864706,5.24464286 L1.85864706,5.24464286 C0.628117647,5.24464286 -0.0704117647,6.15321429 0.300647059,7.27714286 L2.42417647,13.7067857 C2.60858824,14.2671429 3.25347059,14.7214286 3.88382353,14.7214286 L9.956,14.7214286",
    id: "Shape",
    stroke: "#80959D",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9748235,5.24464286 L17.1648235,5.24464286 C18.3953529,5.24464286 19.0938824,6.15321429 18.7217059,7.27714286 L16.5981765,13.7067857 C16.4137647,14.2671429 15.77,14.7214286 15.1396471,14.7214286 L9.06747059,14.7214286 M5.56811765,7.98857143 L5.56811765,11.985 M13.433,7.98857143 L13.433,11.985 M9.5,7.98857143 L9.5,11.985 M11.5844118,5.46321429 L7.41558824,5.46321429",
    id: "Shape",
    stroke: "#80959D",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#80959D",
    fillRule: "nonzero",
    cx: 4.38788235,
    cy: 5.27785714,
    rx: 1.57252941,
    ry: 1.5075
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#80959D",
    fillRule: "nonzero",
    cx: 14.6121176,
    cy: 5.27785714,
    rx: 1.57252941,
    ry: 1.5075
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76094118,0.477857143 L4.46723529,5.06785714 M11.5452941,0.477857143 L14.839,5.06785714",
    id: "Shape",
    stroke: "#80959D",
    strokeWidth: 1.1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.b4d0bd775a14a6a3f8f906840417f928.svg";
export { ForwardRef as ReactComponent };